/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VirtualMeetingAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconEvent from 'DesignSystem/Svgs/TysiaIconEvent/index'



/** @type {import('Simple/types.js').View} */
export default function VirtualMeetingAction({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/Internal/Tools/VirtualMeetingAction"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 type="ghost"
 size="small"
 marginRight={8}
 marginTop={0}
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaIconEvent
{...childProps}
  viewPath={`${viewPath}/TysiaIconEvent`}
 width={16}
 height={16}
 marginRight={4}
/>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 type="secondary"
 text="Join Virtual Meeting"
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}